module.exports = __webpack_public_path__ + "img/zha.5f731168.png";